import { defineMessages } from 'react-intl';

export default defineMessages({

    additionalInterest: {
        id: 'quoteandbind.residential.additionalInfo.policychange.Additional Interests',
        defaultMessage: 'Additional Interests',
    },
    additionalInsured: {
        id: 'quoteandbind.residential.additionalInfo.policychange.Additional Named Insureds',
        defaultMessage: 'Additional Named Insureds',
    },
    

});
